import { ref, computed } from '@nuxtjs/composition-api';
import { useAuthentication } from '~/composables/auth/useAuthentication';
import { useStore } from '~/composables/useStore';
import { COMMENT_SORT_OPTIONS, COMMENT_PAGES } from '~/constants/comments';
import { SORT_PARAMETERS } from '~/constants/sortParameters';
import { CommentSortOptions } from '~/types/modules/sort';

export const useComment = (commentPage: string) => {
  const store = useStore();
  const { isAuthenticated } = useAuthentication();
  const currentSortIndex = ref(getInitialSortIndex());
  const likedComments = ref<number[]>([]);

  // クチコミ画面によって、絞り込みの初期値が違う
  function getInitialSortIndex(): number {
    switch (commentPage) {
      case COMMENT_PAGES.MYPAGE:
        return store.state.modules.reviews.myPageCommentsSortIndex;
      case COMMENT_PAGES.USER:
        return store.state.modules.reviews.userCommentsSortIndex;
      default:
        return 0;
    }
  }

  const currentSortParameter = computed(() => {
    const currentSortParameter = COMMENT_SORT_OPTIONS.find((option) => option.index === currentSortIndex.value);
    return (currentSortParameter?.target?.toString() as CommentSortOptions) || SORT_PARAMETERS.CREATED_AT;
  });

  const fetchLikedComments = async () => {
    // クチコミを見るためログインは不要なので、ユーザーが「いいね」したコメントも取得必要がない
    if (!isAuthenticated.value) return;
    const likedCommentsResponse = await store.dispatch('modules/reviews/fetchLikedComments', { body: {} });
    likedComments.value = likedCommentsResponse.review_ids;
  };

  // ユーザーがいいねボタンを押下した時、クライアント側のいいね配列を更新する
  const handleLikeChange = (isCommentLiked: boolean, commentId: number) => {
    if (isCommentLiked) {
      likedComments.value.push(commentId);
    } else {
      likedComments.value = likedComments.value.filter((id: number) => id !== commentId);
    }
  };

  return {
    currentSortIndex,
    likedComments,
    currentSortParameter,
    fetchLikedComments,
    handleLikeChange,
  };
};
